module.exports = __webpack_public_path__ + "img/exam (3).014a8971.png";